import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ConfigsService, GLOBALS_TOKEN, IGlobals } from '@overa/shared';
import { DynamicUICodeService, DynamicViewService } from '@overa/dynamic/common';

/**
 * Overrides DynamicUICodeService.apiBaseUrl to use the microservice context
 * set by DynamicViewService.setCurrentApi().
 *
 * When the user selects a microservice in the Backoffice editor and navigates
 * to edit a dynamic view, DynamicViewService.currentbaseUrlApi is already set
 * to  `{backofficeUrl}/api/{microService}`. This service reuses that value
 * so calls go to `/api/{microService}/dynamicUICode` (proxied through the
 * Backoffice API's DynamicViewOrchestratorController) instead of the default
 * `/api/Dynamic/dynamicUICode` (which does not exist on the Backoffice API).
 */
@Injectable({ providedIn: 'root' })
export class BackofficeDynamicUICodeService extends DynamicUICodeService {
  constructor(
    http: HttpClient,
    config: ConfigsService,
    @Inject(GLOBALS_TOKEN) globals: IGlobals,
    private readonly dynamicViewService: DynamicViewService,
  ) {
    super(http, config, globals);
  }

  override get apiBaseUrl(): string {
    // getCurrentBaseUrlApi() returns  {backofficeUrl}/api/{microService}
    // The DynamicUICode endpoints are nested under the dynamic-view controller:
    //   {backofficeUrl}/api/{microService}/dynamic-view/dynamicUICode
    // Appending '/dynamic-view' here keeps BaseService's path concatenation correct.
    const base = this.dynamicViewService.getCurrentBaseUrlApi();
    return base ? `${base}/dynamic-view` : super.apiBaseUrl;
  }
}
